var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-button',{staticClass:"article-btn-play",attrs:{"raised":!_vm.isReading,"large":"","fill":"","color":_vm.color},on:{"click":_vm.play}},[_c('FlatIcon',{attrs:{"size":32,"name":_vm.icon}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }